import { config } from '@iheartjane/config';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@jane/shared/data-access';
import type { StoreSpecial } from '@jane/shared/types';

const getStoreSpecials = async (
  storeId: string | number,
  sort?: string,
  includeHidden: boolean = true
) => {
  const params = new URLSearchParams();

  if (sort) params.set('sort', sort);

  params.set('include_hidden', `${includeHidden}`);

  const query = params.toString();
  const url = `${config.apiPath}/stores/${storeId}/specials${query ? `?${query}` : ''}`;

  const { specials } = await api.get<{ specials: StoreSpecial[] }>(url);
  return specials;
};

export const getSpecialsQueryOptions = (
  storeId: string | number,
  options: { enabled: boolean; includeHidden?: boolean; sort?: string } = {
    enabled: true,
  }
) =>
  queryOptions({
    enabled: options.enabled,
    queryFn: () =>
      getStoreSpecials(storeId, options.sort, options.includeHidden),
    queryKey: ['storeSpecials', options.sort, storeId, options.includeHidden],
  });

export const useGetStoreSpecials = (
  storeId: string | number,
  options: { enabled: boolean; includeHidden?: boolean; sort?: string } = {
    enabled: true,
  }
) => {
  return useQuery(getSpecialsQueryOptions(storeId, options));
};
